const chat_styles = {
    background: '#f5f8fb',
    fontFamily: 'Helvetica Neue',
    headerBgColor: '#3333ff',
    headerFontColor: '#fff',
    headerFontFamily: 'Montseratt',
    botBubbleColor: '#3333ff',
    botFontColor: '#fff',
    userBubbleColor: '#fff',
    userFontColor: '#4a4a4a',
  };
  
  export default chat_styles;